export default __webpack_public_path__ + "static/media/Obviously550.3881c235.otf";